// PopupComponent.jsx
import React from "react";
import "./popupComponent.scss";
import Button from "../button/buttonComponent";

const Popup = ({ show, onClose, buttons, onSave, header, children }) => {

  return (
    <div
      className={"orgSettingPopup popupContainer right " + (show ? "show" : "")}
      onClick={(e) => e.stopPropagation()}
    >
        <div className="popupInner">
            <div className="popupHeader">
                <i className="fa fa-cog"></i> {header || "Popup"}
            </div>

            <div className="popupBody">
                {children}
            </div>

            {
                buttons ?
                <div className="popupFooter">
                    <Button className={"small white"} onClick={onClose}><span>Cancel</span></Button>
                    <Button className={"small"} onClick={onSave}><span>Save</span></Button>
                </div> : ""
            }

        </div>
    </div>
  );
};

export default Popup;
